import React, { useRef, useMemo } from 'react';
import { AddImgWrapper, AddImgBorderContainer } from '../../styles/editStyle';
import { STextBold } from '../../styles/textStyle';
import AddIcon from '../../home/icons/AddIcon';
import CameraIcon from '../../home/icons/CameraIcon';
import { Phrase } from '../../Phrase';
import styled from 'styled-components';
import DetectRTC from 'detectrtc';

const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
`;
// Logic:
// Since Android 14 the <input type="file" accept="image/*"> is no longer opens both camera and gallery options
// But it opens only the gallery (and we cannot relay on OS version detection since chrome do not expose it since 2023)
// Therefor for android we show both regular input, and also capture input for camera, but in ios we show only regualr since it opens both camera and gallery.


export const CameraGalleryButtons = ({
  printStatus,
  editImageStyle,
  buttonBackground,
  addImage,
  openCameraText,
  onFileSelected,
  workflows
}) => {
  const galleryInputRef = useRef();
  const cameraInputRef = useRef();

  const openGallery = () => galleryInputRef.current?.click();
  const openCamera = () => cameraInputRef.current?.click();

  const isGalleryEnabled = workflows?.isGalleryEnabled;
  const isSnapEnabled = workflows?.isSnapEnabled;

  const isIOS = useMemo(() => DetectRTC.osName === 'iOS', []);

  const renderGalleryButton = () => (
    <AddImgWrapper disabled={!printStatus} style={editImageStyle} onClick={openGallery}>
      <input
        type="file"
        accept="image/*"
        onChange={onFileSelected}
        ref={galleryInputRef}
        disabled={!printStatus}
        style={{ display: 'none' }}
      />
      <AddImgBorderContainer borderColor={buttonBackground} textColor={buttonBackground}>
        <AddIcon style={{ fill: buttonBackground || 'black' }} />
        <STextBold>
          <Phrase
            Key={addImage.translationKey === '' ? '' : 'fd4c8a1c-8397-44d6-a90c-816d55b3d4b6'}
            default={addImage.text || ''}
          />
        </STextBold>
      </AddImgBorderContainer>
    </AddImgWrapper>
  );

  const renderCameraButton = () => (
    <AddImgWrapper disabled={!printStatus} style={editImageStyle} onClick={openCamera}>
      <input
        type="file"
        accept="image/*"
        capture="user"
        onChange={onFileSelected}
        ref={cameraInputRef}
        disabled={!printStatus}
        style={{ display: 'none' }}
      />
      <AddImgBorderContainer borderColor={buttonBackground} textColor={buttonBackground}>
        <CameraIcon fill={buttonBackground} />
        <STextBold>
          <Phrase
            Key={openCameraText.translationKey}
            default={openCameraText.text || 'Open Camera'}
          />
        </STextBold>
      </AddImgBorderContainer>
    </AddImgWrapper>
  );

  if (isIOS) {
    return (
      <ButtonsContainer>
        {/* In IOS we show only 1 button */}
        {isGalleryEnabled ? renderGalleryButton() : renderCameraButton()}
      </ButtonsContainer>)
  }

  return (
    <ButtonsContainer>
      {isGalleryEnabled && renderGalleryButton()}
      {isSnapEnabled && renderCameraButton()}
    </ButtonsContainer>
  );
};
